<div class="menu-items">
    <div class="menu-item"
        [ngClass]="{'selected-menu': url === '/portal/personal-info/photos' || url === '/portal/personal-info'}"
        (click)="selectMenu('photos')">
        Photos<span></span>
    </div>
    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/personal-info/bio-contact-info'}"
        (click)="selectMenu('bio-contact-info')">
        Bio/Contact Info<span></span>
    </div>
    <!-- <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/personal-info/qr-code'}"
        (click)="selectMenu('qr-code')">
        QR Code<span></span>
    </div> -->

    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/personal-info/mls-ids'}"
        (click)="selectMenu('mls-ids')">
        MLS ID's<span></span>
    </div>
    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/personal-info/designations'}"
        (click)="selectMenu('designations')">
        Designations<span></span>
    </div>
    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/personal-info/specialties'}"
        (click)="selectMenu('specialties')">
        Specialties<span></span>
    </div>
    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/personal-info/language-spoken'}"
        (click)="selectMenu('language-spoken')">
        Languages Spoken<span></span>
    </div>
    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/personal-info/counties-cities-served'}"
        (click)="selectMenu('counties-cities-served')">
        Cities Served<span></span>
    </div>
    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/personal-info/display-options'}"
        (click)="selectMenu('display-options')">
        Display Options<span></span>
    </div>
    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/personal-info/social-network'}"
        (click)="selectMenu('social-network')">
        Social Network Affiliations<span></span>
    </div>
    <div class="menu-item" *ngIf="!isDelegateUser" [ngClass]="{'selected-menu': url === '/portal/personal-info/manage-by-delegates'}"
        (click)="selectMenu('manage-by-delegates')">
        Manage My Delegates<span></span>
    </div>
</div>